import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=79f53a68&scoped=true&"
import script from "./MenuItem.vue?vue&type=script&lang=js&"
export * from "./MenuItem.vue?vue&type=script&lang=js&"
import style0 from "@/styles/components/MenuItem/MenuItem.less?vue&type=style&index=0&id=79f53a68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f53a68",
  null
  
)

export default component.exports